export const cannotCreateToast = {
  title: '您无权限建立此追踪工具',
  title_auto: '您无权限建立任何追踪工具，请联系店长开启编辑权限',
};
